import { clsx } from "@/utils";

export type PanelProps = React.HTMLAttributes<HTMLDivElement>;

export const Panel = ({ children, className, ...props }: PanelProps) => {
  return (
    <div className={clsx("w-full rounded-lg border border-neutral-mid-gray bg-white p-5", className)} {...props}>
      {children}
    </div>
  );
};
